import clsx from 'clsx';
import React from 'react';

export function ProfileContent({ className = '', children }: React.PropsWithChildren<{ className?: string }>) {
  return <div className={clsx(className, 'modal-content', 'p-4 sm:p-10')}>{children}</div>;
}
